// White-label branding — PSD §10.4 (F10.4). State layer.

export interface BrandingConfig {
  entityName: string;
  logoUrl: string | null;
  accentColor: string;
  footerCopy: string;
}

const DEFAULT_BRANDING: BrandingConfig = {
  entityName: 'Backsolve',
  logoUrl: null,
  accentColor: '#1a5fb4',
  footerCopy: 'This tool does not constitute legal or tax advice. Consult a qualified professional.',
};

const BRANDING_KEY = 'backsolve_branding';

export function getBranding(): BrandingConfig {
  try {
    const raw = localStorage.getItem(BRANDING_KEY);
    if (!raw) return DEFAULT_BRANDING;
    return { ...DEFAULT_BRANDING, ...(JSON.parse(raw) as Partial<BrandingConfig>) };
  } catch {
    return DEFAULT_BRANDING;
  }
}

export function setBranding(config: Partial<BrandingConfig>): void {
  const current = getBranding();
  const merged = { ...current, ...config };
  localStorage.setItem(BRANDING_KEY, JSON.stringify(merged));
  // Apply accent color immediately
  if (config.accentColor) {
    document.documentElement.style.setProperty('--color-accent', config.accentColor);
  }
}

export function resetBranding(): void {
  localStorage.removeItem(BRANDING_KEY);
  document.documentElement.style.setProperty('--color-accent', DEFAULT_BRANDING.accentColor);
}

export { DEFAULT_BRANDING };
